// ABOUTME: Reusable footer component with privacy policy and terms of service links
// ABOUTME: Displays policy links as router navigation to dedicated pages

import React from 'react';
import {
  Box,
  Typography,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface FooterProps {
  variant?: 'login' | 'app';
}

const Footer: React.FC<FooterProps> = ({ variant = 'login' }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Box
        component="footer"
        role="contentinfo"
        sx={{
          mt: variant === 'login' ? 4 : 2,
          py: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
          backgroundColor: variant === 'app' ? 'background.paper' : 'transparent'
        }}
      >
        <Box sx={{ mb: 1 }}>
          <Link
            component={RouterLink}
            to="/privacy"
            color="text.secondary"
            sx={{ mx: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            aria-label="Privacy Policy"
          >
            Privacy Policy
          </Link>
          <Typography component="span" sx={{ color: 'text.secondary' }}>
            |
          </Typography>
          <Link
            component={RouterLink}
            to="/terms"
            color="text.secondary"
            sx={{ mx: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            aria-label="Terms of Service"
          >
            Terms of Service
          </Link>
        </Box>
        
        <Typography variant="body2" color="text.secondary">
          © {currentYear} Let&apos;s Reset. All rights reserved.
        </Typography>
      </Box>
    </>
  );
};

export default Footer;